import { NgModule } from '@angular/core';
import { ReviewsService } from './services';

@NgModule({
  providers: [ReviewsService]
})
export class DomainReviewsModule {}